import readXlsxFileAsJson from '../../shared/xlsxImport/readXlsxFileAsJson';
import excelFileTypeValidator from '../../shared/xlsxImport/validators/excelFileType.validator';
import columnHeadersValidator from '../../shared/xlsxImport/validators/columnHeaders.validator';
import noEmptyRowsValidator from '../../shared/xlsxImport/validators/noEmptyRows.validator';
import calculateImportRangeFactory from '../../shared/xlsxImport/calculateImportRangeFactory';
import columnIndexToName from '@common/xlsxExport/utils/columnIndexToName';
import emptyRowsTrimmer from '../../shared/xlsxImport/processors/emptyRowsTrimmer.processor';
import { ExcelUser } from '../../shared/queries/users';

import { FIELD_MAPPINGS, MAX_COLUMNS_NUMBER, MIN_COLUMNS_NUMBER } from './constants';
import { columnHeaders } from './columnHeaders';
import { fieldNormalizers } from './fieldNormalizers';

export const readUsersAndPrivilegesFile = async (file: File) => await readXlsxFileAsJson({
  file,
  fileValidators: [excelFileTypeValidator] as any,
  prevalidators: [columnHeadersValidator] as any,
  postvalidators: [noEmptyRowsValidator] as any,
  fieldMappings: FIELD_MAPPINGS,
  sheetName: 'USERS AND PRIVILEGES',
  getRange: calculateImportRangeFactory(columnIndexToName(MAX_COLUMNS_NUMBER)) as any,
  preprocessors: [emptyRowsTrimmer] as any,
  mapToJsonOptions: {
    header: columnHeaders,
  },
  validationData: {
    columnHeaders,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
  },
  fieldNormalizers: fieldNormalizers as any,
}) as ExcelUser[];
